import React from "react";
import { Link } from "react-router-dom";
import "./DashboardHeader.scss"; 
const DashboardHeader = () => {

  return (
    <div className="dashboard-header">
      <div className="dashboard-header__logo">
        <Link to="/">
          <img
            src="https://res.cloudinary.com/dgvb7ghfd/image/upload/f_auto,q_auto/sswyskszdqd6tqkt0pq7"
            alt="logo"
          />
        </Link>
      </div>

      <div className="dashboard-header__icons">
       Хорошого робочого дня!
      </div>
    </div>
  );
};

export default DashboardHeader;
